import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAddressType } from '../../Interfaces/IAddressType';

const initialState = { storeAddressType: [] as IAddressType[] };

const sliceBusinessForm = createSlice({
  name: 'BusinessFormARRAY',
  initialState,
  reducers: {
    setAdressTypeArray: (state, action: PayloadAction<IAddressType[]>) => {
      state.storeAddressType = [...action.payload];
    },
    addUpdateAdressTypeArray: (state, action: PayloadAction<IAddressType>) => {
      const testObject = state.storeAddressType.find(
        x => x.idAddresstype === action.payload.idAddresstype
      );

      if (testObject) {
        state.storeAddressType = [
          ...state.storeAddressType.map(x =>
            x.idAddresstype === action.payload.idAddresstype
              ? action.payload
              : x
          ),
        ];
      } else {
        state.storeAddressType = [action.payload, ...state.storeAddressType];
      }
    },
  },
});
export const { setAdressTypeArray, addUpdateAdressTypeArray } =
  sliceBusinessForm.actions;
export default sliceBusinessForm.reducer;
